<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-12 col-md-12 col-12 bg-light panelDiv" style="margin-left: 5px;">
                            <h4 class="mb-4 font-ss">Welcome to DTC Dashboard</h4>
                            <p class="font-ss">Direct Tax Compliance (DTC) is an application to reconcile the bank statement with the ERP report for Accounting Compliance Reconciliation (ACR) clients and to calculate Corporate Income Tax (CIT) for the Brazil Tax Corporation (BTC) clients.</p>
                            <div class="panelDiv">
                                <div class="col-sm-12 mb-4">
                                    <div class="card-deck font-ss">
                                        <a href="#" v-for="(appdetails, index) in AppList.applications" v-bind:aria-label="'Press enter to open ' + appdetails.applicationFullName + ' Application'" v-bind:title="appdetails.applicationFullName + ' Tile'" v-bind:key="index.id" class="card mb-3 card-columns" style="max-width: 18rem;cursor:pointer;text-decoration:none;color:black;" v-bind:id="'btn' + appdetails.id" v-on:click="handleButtonEvent($event,appdetails.appKey)">
                                            <div class="card-header text-center" style="font-weight:bold">{{appdetails.name}}</div>
                                            <div class="card-body">
                                                <h5 class="card-title" style="font-weight: 500;">{{appdetails.applicationFullName}}</h5>
                                                <p class="card-text">{{appdetails.applicationDescription}}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import LoginService from '../services/login.service.js';
    import Algorithm from "../services/Algorithm.js";
    export default {
        name: 'HomeAD',
        data() {
            return {
                AppList: [],
                idleTime: 0,
                idleInterval: ''
            }
        },
        mixins: [LoginService, Algorithm],
        created() {
            //this.getUserInfo('Vamshi.Krishna.Reddy.Nalla@gds.ey.com');
            if (!this.$msal.isAuthenticated()) {
                this.$msal.signIn();
            }
            else {
               console.log(this.$msal);
               this.CheckRegisterUser(this.$msal.data.user.userName).then(Response => {
                   if (Response.data == 'User is not Registered in Application') {
                       //Fetching User Name , First Name and Family Name from AD
                       //this.saveUserInfo(this.$adal.user.userName, this.$adal.user.profile.given_name, this.$adal.user.profile.family_name);
                   }
                   if (Response.data == 'User Already Registered') {
                       this.getUserInfo(this.$msal.data.user.userName);
                   }
               });
            }
        },
        methods: {
            handleButtonEvent(e, appKey) {
                localStorage.setItem('appName', appKey);
                if (appKey == "BRC") {
                    this.$router.push({ name: 'ACRHome' });
                }
                else if (appKey == "CIT") {
                    this.$router.push({ name: 'CITHome' });
                }
                else if (appKey == "MEMO") {
                    this.$router.push({ name: 'MEMO' });
                }
                else if (appKey == "USBRGAAP") {
                    this.$router.push({ name: 'USBRGAAPHome' });
                }
            },
            getUserInfo(email) {
                var token = localStorage.getItem('adal.idtoken');
                this.login(email, token).then(Response => {
                    if (Response.data.isActive == true) {
                        this.AppList = Response.data;
                        localStorage.setItem('userName', Response.data.userName);
                        localStorage.setItem('userId', Response.data.userId);
                        localStorage.setItem('role', Response.data.role);
                        localStorage.setItem('firstName', Response.data.firstName);
                        localStorage.setItem('lastName', Response.data.lastName);
                        sessionStorage.setItem('appList', JSON.stringify(this.AppList));
                        this.$route.meta.requiresHeader = true;
                    }
                });
                this.getJWTToken(email).then(Response => {
                    localStorage.setItem('JWTToken', Response.data.token);
                });
            },
            saveUserInfo(email, firstname, lastname) {
                this.SaveUserDetails(email, firstname, lastname).then(Response => {
                    if (Response.data == 'Updated Successfully') {
                        //this.$router.push({ name: 'HomeAD' });
                        this.getUserInfo(email);
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .card {
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
    }

        /* On mouse-over, add a deeper shadow */
        .card:hover {
            box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        }

    .font-ss {
        font-family: sans-serif;
    }
</style>